<script setup lang="ts">
import type { Law } from '~/utils/solr/law'

const props = defineProps<{
  law: Law | string | string[]
  isActiveSearchResult?: boolean
}>()

const { lovId, query } = useLawIdParams(props.law)
</script>

<template>
  <NuxtLink
    :to="isActiveSearchResult ? undefined : { name: 'law-by-id', params: { lovId }, query }"
  >
    <slot />
  </NuxtLink>
</template>
